// EC-849-Create a custom redux store to store the data
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { ProductCollectionModel } from "@WhiteCap/Services/ProductGroupingLoadProductService";
import { ProductsState } from "@WhiteCap/Store/Data/ProductsState";
import { Draft } from "immer";

const initialState: ProductsState = {
    isLoading: false,
    products: null,
    attributeTypeFacets: null,
    brandFacets: null,
    categoryFacets: null,
    productPriceProductId: null
};

const reducer = {
    "Custom/GroupingProducts/BeginLoadProducts": (draft: Draft<ProductsState>) => {
        draft.isLoading = true;
    },

    "Custom/GroupingProducts/ProductsPrice": (
        draft: Draft<ProductsState>,
        action: {
            result: SafeDictionary<ProductPriceDto>;
        },
    ) => {
        draft.productPriceProductId = action.result;
    },

    "Custom/GroupingProducts/CompleteLoadProducts": (
        draft: Draft<ProductsState>,
        action: {
            result: ProductCollectionModel;
        },
    ) => {
        draft.products = action.result.products;
        draft.attributeTypeFacets = action.result.attributeTypeFacets;
        draft.brandFacets = action.result.brandFacets;
        draft.categoryFacets = action.result.categoryFacets;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
